import { CALL_ATTEMPTS_FINAL, CALL_RESULTS_NOT_REACHED, type CallResult } from '@/types/inspection-lead'

const NOT_REACHED: readonly CallResult[] = CALL_RESULTS_NOT_REACHED

/** «Дозвонились: передано в ОО», «Не дозвонились: не берёт трубку». */
export function callResultLabel(r: CallResult, t: (k: string) => string): string {
  const group = NOT_REACHED.includes(r) ? t('leads.callResult.notReached') : t('leads.callResult.reached')
  return `${group}: ${t(`leads.callResult.value.${r}`)}`
}

/** «Попытка 2 из 3» / «Попыток: 3, итог» для «не дозвонились». */
export function callAttemptLabel(n: number, t: (k: string, o?: Record<string, unknown>) => string): string {
  return n >= CALL_ATTEMPTS_FINAL
    ? t('leads.callResult.attemptFinal', { n })
    : t('leads.callResult.attempt', { n, total: CALL_ATTEMPTS_FINAL })
}
